//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import '@react/App.css'
import React from 'react'

import LenderApp from '@react/lender/LenderApp'
import { useOtChainState } from '@react/redux/store'
import { RoleEnum } from '@shared/Enums'
import UnconnectedApp from './UnconnectedApp'

import { Typography } from '@mui/material'
import OperatorApp from '@react/operator/OperatorApp'
import AdminApp from '@react/admin/AdminApp'
import BorrowerApp from '@react/borrower/BorrowerApp'
import { logOT } from '@shared/loggingShared'

const DISPLAY_APP_UPDATING = false
export function AppForRoleLender(): React.ReactElement {
  document.title = 'OpenTrade'

  const {
    userConnection,
    userConnection: { roleEnum },
  } = useOtChainState()

  let content

  if (roleEnum === RoleEnum.OPERATOR) {
    content = <OperatorApp />
  } else if (roleEnum === RoleEnum.POOL_ADMIN || roleEnum === RoleEnum.BORROWER) {
    if (location.hostname.startsWith('app.')) {
      logOT.info('Transferring To admin from app')
      content = <UnconnectedApp transferLocation={location.hostname.replace('app', 'admin')} />
    } else {
      logOT.info('AppForRoleLender', location)
      if (roleEnum === RoleEnum.POOL_ADMIN) {
        content = <AdminApp />
      } else if (roleEnum === RoleEnum.BORROWER) {
        content = <BorrowerApp />
      }

      // location.port = '3020'
    }
  } else if (roleEnum === RoleEnum.LENDER) {
    content = <LenderApp />
  } else {
    logOT.info('UnconnectedApp AppForRoleLender', userConnection)
    content = <UnconnectedApp />
  }

  return (
    <div className="app-container" style={{ height: '100%', minHeight: '100vh' }} data-testid="AppForRoleLender">
      {DISPLAY_APP_UPDATING && <Typography variant="h1">Update in Progress.... App will return soon</Typography>}

      {!DISPLAY_APP_UPDATING && (
        <div style={{ height: '100%', minHeight: '100vh', flex: 1, overflow: 'auto' }}>{content}</div>
      )}
    </div>
  )
}
